import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af92ec48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "simple-text-item-0-container" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_4 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.name), 1),
    _hoisted_3,
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.value), 1),
    (_ctx.copyable)
      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
          key: 0,
          class: "copy-icon",
          icon: ['far', 'copy'],
          onClick: _ctx.copyToClipboard
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}